import React, { FunctionComponent } from 'react';

import { Advantage } from '@domains/advantage';

import { AdvantageCard } from '@components/common/AdvantageCard/AdvantageCard';
import { Container } from '@components/common/Container/Container';

import styles from './HomeAdvantages.module.scss';

type HomeAdvantagesProps = {
    advantages: Advantage[];
};
export const HomeAdvantages: FunctionComponent<HomeAdvantagesProps> = (props) => {
    const { advantages } = props;

    return (
        <div className={styles.root}>
            <Container>
                <ul className={styles.grid}>
                    {advantages.map(({ name, image, short_description }, index) => (
                        <li className={styles.item} key={index}>
                            <AdvantageCard
                                name={name}
                                short_description={short_description}
                                image={image}
                            />
                        </li>
                    ))}
                </ul>
            </Container>
        </div>
    );
};
